// extracted by mini-css-extract-plugin
export default {"btn_wrapper":"style_btn_wrapper__bxLLi","back":"style_back__wnC9i","next":"style_next__oxDKI"};